export enum MediaDayTimeFilter {
  AllDay = "ALL_DAY",
  FromNow = "FROM_NOW",
  Morning = "MORNING",
  Afternoon = "AFTERNOON",
  Evening = "EVENING",
}
